<se-fe-card *ngIf="loaded">
  <se-po-persona-avatar
    class="persona-avatar"
    headerDataSize="700"
    [persona]="persona">
  </se-po-persona-avatar>
  <se-fe-card-content>
    <form
      [formGroup]="form"
      novalidate>
      <se-fe-grid seFeGridOpts="snug">
        <se-fe-grid-cell *ngIf="!showEmail || !showPhone" seFeGridOpts="1/1">
          <se-fe-chip-group>
            <se-fe-chip
              *ngIf="!showEmail"
              [seFeDataText]="'SE_PO_UI_CHILD_CONTACT_INFO.ADD_FIELD.email' | translate"
              seFeDataStyle="primary"
              seFeDataIconLeft="plus_circle_outline"
              (seFeClick)="showEmail=true">
            </se-fe-chip>
            <se-fe-chip
              *ngIf="!showPhone"
              [seFeDataText]="'SE_PO_UI_CHILD_CONTACT_INFO.ADD_FIELD.phone' | translate"
              seFeDataStyle="primary"
              seFeDataIconLeft="plus_circle_outline"
              (seFeClick)="showPhone=true">
            </se-fe-chip>
          </se-fe-chip-group>
        </se-fe-grid-cell>
        <se-fe-grid-cell *ngIf="showEmail" seFeGridOpts="1/1">
          <se-po-email
            formControlName="email"
            [seFeDataLabel]="'SE_PO_UI_CHILD_CONTACT_INFO.LABELS.email' | translate">
          </se-po-email>
        </se-fe-grid-cell>
        <se-fe-grid-cell *ngIf="showPhone" seFeGridOpts="1/1">
          <se-po-phone #phone
            formControlName="phone"
            [seFeDataLabel]="'SE_PO_UI_CHILD_CONTACT_INFO.LABELS.phone' | translate">
          </se-po-phone>
        </se-fe-grid-cell>
      </se-fe-grid>
    </form>
  </se-fe-card-content>
</se-fe-card>
